import { render } from "./AuthRole.vue?vue&type=template&id=8b8cacc2"
import script from "./AuthRole.vue?vue&type=script&lang=js"
export * from "./AuthRole.vue?vue&type=script&lang=js"

import "./AuthRole.vue?vue&type=style&index=0&id=8b8cacc2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__